module.exports = __webpack_public_path__ + "img/loading_text_b.096692c8.svg";